import React from 'react';
import { SkeletonProps } from 'antd';

import { StyledAntdSkeleton } from './style';

const CVSkeleton = (props: SkeletonProps): JSX.Element => (
  <StyledAntdSkeleton {...props} />
);

CVSkeleton.Button = StyledAntdSkeleton.Button;
CVSkeleton.Input = StyledAntdSkeleton.Input;
CVSkeleton.Avatar = StyledAntdSkeleton.Avatar;

export default CVSkeleton;
